import React from 'react'
import { Select, Avatar } from 'antd'
import { TicketType } from '../../Show'

type Props = {
  ticket: TicketType
  setDelegateTo: (value: string[]) => void
}

const { Option } = Select

const Delegate: React.FC<Props> = ({ ticket, setDelegateTo }) => {
  const users = window.c.users.filter(user => !user.removed)
  const client = ticket.client
  const { OptGroup } = Select
  const guards = client && client.guards.length ? ticket.client.guards : null

  const handleChange = value => {
    setDelegateTo(value)
  }

  return (
    <Select
      mode="multiple"
      className="ticket-show-delegate-select"
      placeholder={intl.formatMessage({
        id: 'ticket / editor / delegate / select / title',
      })}
      onChange={handleChange}
      defaultValue={ticket.assignedUsers}
      defaultOpen={true}
      optionLabelProp="label"
      filterOption={(input, option) =>
        // @ts-ignore
        option.label.toLocaleLowerCase().indexOf(input.toLocaleLowerCase()) >= 0
      }
    >
      {ticket.client && guards ? (
        <>
          <OptGroup
            label={intl.formatMessage({
              id: 'ticket / editor / delegate / select / guards',
            })}
          >
            {ticket.client.guards.map(user => {
              const guard = window.c.users.find(userData => userData.id == user)

              return (
                guard && (
                  <Option key={user} value={guard.id} label={guard.name}>
                    <Avatar className="mr-3" size="small" src={guard.avatar} />
                    {guard.name}
                  </Option>
                )
              )
            })}
          </OptGroup>
          <OptGroup
            label={intl.formatMessage({
              id: 'ticket / editor / delegate / select / other',
            })}
          >
            {users.map(user => (
              <>
                {guards.indexOf(user.id) == -1 && (
                  <Option key={user.id} value={user.id} label={user.name}>
                    <Avatar
                      className="ticket-show-delegate-avatar"
                      size="small"
                      src={user.avatar}
                    />
                    {user.name}
                  </Option>
                )}
              </>
            ))}
          </OptGroup>
        </>
      ) : (
        <>
          {users.map(user => (
            <Option key={user.id} value={user.id} label={user.name}>
              <Avatar
                className="ticket-show-delegate-avatar"
                size="small"
                src={user.avatar}
              />
              {user.name}
            </Option>
          ))}
        </>
      )}
    </Select>
  )
}

export default Delegate
